import PPlusNotify from '@/resources/PPlusNotify';

export default {
    mixins: [PPlusNotify],
    methods: {
        validatePaid(link) {
            let loader = this.$WeHelper.modalLoad();
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {};

            this.$WeHelper.postAPI(apiURL, '/api/user/get-account-content', postData, this.$PPlusEngine.getHeaderToken()).then((response) => {
                if (!this.$WeHelper.isNullOrEmpty(response.data)) {
                    if (response.data.paymentStatus == this.$PPlusConstant.PaymentStatus_None) {
                        this.alertPleaseMakePayment(this.$router);
                    }
                    else if (response.data.paymentStatus == this.$PPlusConstant.PaymentStatus_WaitForConfirm) {
                        this.alertPleaseWaitForPaymentConfirm();
                    }
                    else {
                        this.$router.push(link);
                    }
                }
                else {
                    this.alertPleaseLogin();
                }

                loader.hide();
            });
        }
    }
}